import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ErrorDialogData } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-alert-toast-dialog',
  templateUrl: './alert-toast-dialog.component.html',
  styleUrls: ['./alert-toast-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertToastDialogComponent {

  constructor(
    public snackBarRef: MatSnackBarRef<AlertToastDialogComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ErrorDialogData
  ) { }

  onClose(): void {
    this.snackBarRef.dismiss();
  }
}
